<template id="chessground">
  <div>
    <svg :width="dimension" :height="dimension">
      <defs>
        <marker
          id="arrow-red-inactive"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#FF000055" />
        </marker>
        <marker
          id="arrow-green-inactive"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#3B652155" />
        </marker>
        <marker
          id="arrow-blue-inactive"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#000DFF55" />
        </marker>
        <marker
          id="arrow-yellow-inactive"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#C99E3655" />
        </marker>

        <marker
          id="arrow-red"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#f00" />
        </marker>
        <marker
          id="arrow-green"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#0f0" />
        </marker>
        <marker
          id="arrow-blue"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#00f" />
        </marker>
        <marker
          id="arrow-yellow"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#ffa500" />
        </marker>
        <marker
          id="arrow-purple"
          markerWidth="10"
          markerHeight="10"
          refX="0"
          refY="2"
          orient="auto"
          markerUnits="strokeWidth"
        >
          <path d="M0,0 L0,4 L5,2 z" fill="#80f" />
        </marker>
      </defs>

      <g
        v-for="(occupation, index) in state"
        v-bind:key="occupation + '' + index"
      >
        <rect
          v-if="occupation === 0"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          :width="dimension / 3"
          :height="dimension / 3"
          stroke="lightgray"
          style="fill: rgb(255, 255, 255)"
          stroke-width="1"
        />

        <image
          v-else-if="occupation === 1 && figureType === 1"
          :width="dimension / 3"
          :height="dimension / 3"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          xlink:href="../assets/c-human.svg"
        />

        <image
          v-else-if="occupation === 1 && figureType !== 1"
          :width="dimension / 3"
          :height="dimension / 3"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          xlink:href="../assets/monkey.svg"
        />

        <image
          v-else-if="occupation === 2 && figureType === 1"
          :width="dimension / 3"
          :height="dimension / 3"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          xlink:href="../assets/c-robot.svg"
        />

        <image
          v-else-if="occupation === 2 && figureType === 2"
          :width="dimension / 3"
          :height="dimension / 3"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          xlink:href="../assets/robot.svg"
        />

        <image
          v-else-if="occupation === 2 && figureType === 0"
          :width="dimension / 3"
          :height="dimension / 3"
          :x="(dimension / 3) * (index % 3)"
          :y="(dimension / 3) * Math.floor(index / 3)"
          xlink:href="../assets/croco.svg"
        />
      </g>
      <g v-for="(action, index) in actions" :key="index">
        <line
          :x1="(dimension / 3) * (action[0] % 3) + dimension / 6"
          :y1="(dimension / 3) * Math.floor(action[0] / 3) + dimension / 6"
          :x2="(dimension / 3) * (action[1] % 3) + dimension / 6"
          :y2="(dimension / 3) * Math.floor(action[1] / 3) + dimension / 6"
          :stroke="
            sweets[index] > 0
              ? colorsActive[index].hex
              : colorsInactive[index].hex
          "
          stroke-width="3"
          :marker-end="
            sweets[index] > 0
              ? colorsActive[index].name
              : colorsInactive[index].name
          "
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Chess",
  props: {
    state: Array,
    dimension: { type: Number, default: 180 },
    actions: Array,
    sweets: Array,
    figureType: Number,
  },
  data: function () {
    return {
      colorsActive: [
        { name: "url(#arrow-blue)", hex: "#00f", fill: "blue" },
        { name: "url(#arrow-red)", hex: "#f00", fill: "red" },
        { name: "url(#arrow-green)", hex: "#0f0", fill: "#3B6521" },
        { name: "url(#arrow-yellow)", hex: "#ffa500", fill: "orange" },
        { name: "url(#arrow-purple)", hex: "#80f", fill: "purple" },
      ],
      colorsInactive: [
        {
          name: "url(#arrow-blue-inactive)",
          hex: "#000DFF55",
          fill: "#000DFF55",
        },
        {
          name: "url(#arrow-red-inactive)",
          hex: "#FF000055",
          fill: "#FF000055",
        },
        {
          name: "url(#arrow-green-inactive)",
          hex: "#3B652155",
          fill: "#3B652155",
        },
        {
          name: "url(#arrow-yellow-inactive)",
          hex: "#C99E3655",
          fill: "#C99E3655",
        },
        { name: "url(#arrow-purple-inactive)", hex: "#80f", fill: "#000" },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
